import {GetMessageCodeText} from "../Output/MessageCodes";
import React from "react";

export default function ResultView({message_key, error_id, children}) {
    return (
        <>
            <div
                style={{
                    marginTop: 4,
                    marginBottom: 4,
                    fontFamily: 'Segoe UI',
                    fontSize: '9pt',
                    backgroundColor: '#f0f2f5',
                    paddingLeft: 8,
                    paddingRight: 4,
                    paddingTop: '1mm',
                    paddingBottom: '1mm',
                    textAlign: 'start',
                }}
            >
                <b>Message Code: {GetMessageCodeText(message_key, error_id)}</b>
            </div>
            <div style={{paddingLeft: 8, maxWidth: '22cm'}}>
                {children}
            </div>
        </>
    )
}